import React from "react";
import {useSelector} from "react-redux";
import {LinearProgress, withStyles} from "@material-ui/core";
import {BRCustomizedTooltip as Tooltip} from "../accents/BRCustomizedTooltip";
import Widget from "../../prefabricated/Widget";
import InfoSharpIcon from "@material-ui/icons/InfoSharp";
import {Row, Col, } from 'reactstrap'

const BorderLinearProgressDeterminate = withStyles((theme) => ({
    root: {
        height: 20,
        borderRadius: 15,
        marginTop: 5,
        marginRight: 5,
    },
    dashed: {
        height: 30,
        lineHeight: 10,
    },
    colorPrimary: {
        // backgroundColor: theme.palette.grey[theme.palette.type === 'light' ? 100 : 700],
        backgroundColor: theme.palette.grey[400],
        // backgroundColor: "#263440"
    },
    bar: {
        // borderRadius: 5,
        backgroundColor: "#5F1615",
    },
    bar1Buffer: {
        // borderRadius: 5,
        backgroundColor: "#5F1615",
    },
}))(LinearProgress);

const Tile = ({
                  displayModeInlineTableHeader = false
              }) => {

    // const { entityId , title} = props;

    const {customerInView} = useSelector(({customer}) => customer);
    const { portfolios} = useSelector(({breachrisk}) => breachrisk);

    const portfolio = portfolios && portfolios[customerInView] ? portfolios[customerInView] : null;
    const portfolioMeta = portfolio ? portfolio.meta : null;

    const portfolioSize = portfolioMeta ? portfolioMeta.portfolio_size : "Loading...";

    // console.log("PORTFOLIO META, ", portfolioMeta);
    const authPortfolioSize = portfolioMeta ? portfolioMeta.auth_portfolio_size : null;

// console.log( typeof portfolioSize, typeof authPortfolioSize,  typeof (portfolioSize/authPortfolioSize))
    return(
        <>
            {displayModeInlineTableHeader
                ?                             <Tooltip title={`You currently have ${portfolioSize} companies in your portfolio. Your subscription allows you to have up to ${authPortfolioSize}.`}>
                    <div style={{minWidth:"250px", width:"450px"}} className={`pl-0 pr-1 pb-0 pt-0 bg-light`}>
                    {/*<Tooltip disableFocusListener title={`You currently have ${portfolioSize} companies in your portfolio. Your subscription allows you to have up to ${authPortfolioSize}.`}>*/}
                    {/*    <InfoSharpIcon style={{fontSize: "20px", marginLeft: "auto", marginTop: -20, zIndex:5}} className={`text-muted`}/>*/}
                    {/*</Tooltip>*/}
                    <Row>
                        <div className={"col-8 tourNumberCompanies"} id={"tourNumberCompanies"}>
                            <BorderLinearProgressDeterminate value={portfolioMeta ? portfolioSize/authPortfolioSize * 100 : 0} variant="determinate"/>

                        </div>
                        <div className={"col-4 tourNumberCompanies"}>
                                <span>
                                    <h2 className={` pt-1 bb-font-fridge-bold`}>
                                        {portfolioSize} {!isNaN(portfolioSize) && `/ ${authPortfolioSize}`}

                                    </h2>
                                </span>

                        </div>
                    </Row>
                </div>
                </Tooltip>

                : <Widget styleName={`pl-0 pr-2 pb-1 pt-4 bg-light animated fadeIn animation-duration-5 dataTile`}>
                    <Tooltip disableFocusListener title={`You currently have ${portfolioSize} companies in your portfolio. Your subscription allows you to have up to ${authPortfolioSize}.`}>
                        <InfoSharpIcon style={{fontSize: "20px", marginLeft: "auto", marginTop: -20, zIndex:5}} className={`text-muted`}/>
                    </Tooltip>
                    <div className="text-center mt-1">
                        <Row>
                            <Col sm={"4"} className={"ml-2 align-self-center"}>
                                <h1>Companies in Portfolio</h1>
                            </Col>
                            <Col className={"align-self-center"}>
                                <BorderLinearProgressDeterminate value={portfolioMeta ? portfolioSize/authPortfolioSize * 100 : 0} variant="determinate"/>
                                {/*<LinearProgress*/}
                                {/*    variant="determinate"*/}
                                {/*    value={portfolioSize/authPortfolioSize * 100}*/}
                                {/*    style={{*/}
                                {/*        height: 30,*/}
                                {/*        borderRadius: 15,*/}
                                {/*        marginTop: 5,*/}
                                {/*        marginRight: 15,*/}
                                {/*    }}*/}
                                {/*    />*/}
                                <Tooltip title={`You currently have ${portfolioSize} companies in your portfolio. Your subscription allows you to have up to ${authPortfolioSize}.`}>
                                <span>
                                    <h1 className={`mb-2 bb-font-fridge-bold text-center`}>
                                        {portfolioSize} {!isNaN(portfolioSize) && `/ ${authPortfolioSize}`}

                                    </h1>
                                </span>
                                </Tooltip>
                            </Col>

                        </Row>
                    </div>

                </Widget>
            }

        </>

    )
}

export default Tile
